import React, { useState, useEffect, useCallback, useRef } from "react";

import { toast } from "react-toastify";
import moment from 'moment';

import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";
import ReactTooltip from "react-tooltip";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

LoadingOverlay.propTypes = undefined;

const defaultColDef = {
    editable: false,
    sortable: false,
    filter: false,
    resizable: true,
    cellClass: "text-center",
    headerClass: "bg-dark text-light",
    suppressMovable: true,
};

const ManageProduct = ({}) => {
    const [serviceAppList, setServiceAppList] = useState(null);
    const [loadingData, setLoadingData] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(false);

    useEffect(() => {
        if (!serviceAppList) {
            commonData.getServiceAppList(axios, (err, list) => {
                if (!err) {
                    setServiceAppList(list);
                }
            });
        }
        return () => {};
    }, []);

    useEffect(() => {
        return () => {};
    }, [tableData, loadingData]);

    useEffect(() => {
        return () => {};
    }, [showModal, selectedProduct]);

    const listColumn = [
        {
            headerName: "No",
			maxWidth: 50,
            valueGetter: `node.rowIndex + 1`,
        },
        {
            headerName: "ID",
            field: "id",
            hide: true,
        },
        {
            headerName: "상품명",
            field: "name",
            width: 100,
        },
        {
            headerName: "상품 상세",
            field: "description",
            width: 150,
        },
        {
            headerName: "사용 서비스",
            width: 100,
            cellRenderer: (params) => {
                let apps = params.data.appName;
                if(params.data.subApps && params.data.subApps.length > 0) {
                    apps = apps + ',' + params.data.subApps.map((s) => s.appName).join(',');
                }
                return apps;
            },
        },
        {
            headerName: "사용 여부",
            field: "use",
            maxWidth: 100,
            cellRenderer: (params) => {
                if (params.value) {
                    return "사용";
                }
                return "미사용";
            },
        },
        {
            headerName: "수정일",
            cellClass: "text-left",
            maxWidth: 160,
            cellRenderer: (param) => {
                if (param.data.updateDate) {
                    return param.data.updateDate;
                }
                return param.data.createDate ? param.data.createDate : '-';
            },
        },
        {
            headerName: "관리",
            colId: "manager-cell",
            field: "id",
            maxWidth: 100,
		    cellRenderer : (params) => {
		    	return "<button class='btn btn-secondary btn-sm'>수정</button>";
		    }
        },
    ];

    const getData = () => {
        setLoadingData(true);
        axios({
            method: "get",
            url: `/api/system/mngr-product`,
        })
            .then((res) => {
                const result = res.data;
                let list = result.list;
                const listSub = result.listSub;
                list.forEach((p) => {
                    const subApps = listSub.filter((s => p.id == s.appAuthTypeId));
                    p.subApps = subApps;
                });
                setTableData(list);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const onGridReady = useCallback((params) => {
        getData();
    }, []);

    const onRowDataChanged = (params) => {
        params.api.sizeColumnsToFit();
    };

    const onRowClicked = (params) => {
        if (params && params.data) {
            console.debug(params);
        }
    };

    const onCellClicked = (params) => {
        if (params && params.data && params.column.colId == 'manager-cell') {
            showProductModal(params.data.id);
        }
    };

    const showProductModal = (id) => {
        if(id) {
            const selected = tableData.find((p) => p.id == id);
            setSelectedProduct(selected);
        } else {
            setSelectedProduct(false);
        }
        setShowModal(true);
    };

    const onModalClose = (dataRefresh) => {
        setSelectedProduct(false);
        setShowModal(false);
        if(dataRefresh) {
            getData();
        }
    };

    return serviceAppList ? (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">결합 상품 관리</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <LoadingOverlay active={loadingData} spinner>
                        <div className="row align-items-end">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2 text-right">
                                    <Button
                                        className="btn btn-success mr-3"
                                        onClick={() => showProductModal(false)}
                                    >
                                        결합 상품 등록
                                    </Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col ag-theme-balham" style={{ height: "600px" }}>
                                <AgGridReact
                                    onGridReady={onGridReady}
                                    defaultColDef={defaultColDef}
                                    columnDefs={listColumn}
                                    rowData={tableData}
                                    onRowDataChanged={onRowDataChanged}
                                    onCellClicked={onCellClicked}
                                    rowHeight={40}
                                    enableCellTextSelection={true}
                                    ensureDomOrder={true}
                                />
                            </div>
                        </div>
                    </LoadingOverlay>
                </div>
            </div>

            <ProductModal
                show={showModal}
                onHide={onModalClose}
                selected={selectedProduct}
                serviceAppList={serviceAppList}
            />
        </div>
    ) : <></>;
};

const ProductModal = ({ show, onHide, selected = false, serviceAppList }) => {
    const baseProduct = {
        id: null,
        name: '',
        type: '',
        description: '',
        appId: 'tomonote',
        subApps: [],
        use: 0,
        order: 1,
    };
    const [product, setProduct] = useState(false);
    useEffect(() => {
        setProduct(selected ? JSON.parse(JSON.stringify(selected)) : { ...baseProduct });
        return () => {};
    }, [show, selected]);

    const changeHandler = (e) => {
        var { name, value } = e.target;
        const newProduct = { ...product };
        newProduct[name] = value;

        // 주계약 선택 시 결합 서비스에서 제외
        if(name == 'appId') {
            const idx = newProduct.subApps.findIndex((s) => s.appId == value);
            if(idx > -1) {
                newProduct.subApps.splice(idx, 1);
            }
            // 정렬 수정
            newProduct.subApps.forEach((a, index) => a.order = index + 1);
        }

        setProduct(newProduct);
    };

    const onSubAppSelect = (e) => {
        const { name, value, checked } = e.target;
        const idx = product.subApps.findIndex((s) => s.appId == value);
        if(idx > -1 && checked) {
            alert("이미 사용 가능 서비스에 등록된 서비스입니다.");
            return;
        }
        const newProduct = { ...product };
        if(checked) {
            newProduct.subApps.push({appId: value, order: product.subApps.length + 1});
        } else {
            newProduct.subApps.splice(idx, 1);
        }
        // 정렬 수정
        newProduct.subApps.forEach((a, index) => a.order = index + 1);

        setProduct(newProduct);
    };

    const upsertData = () => {
        axios({
            method: "post",
            url: `/api/system/mngr-product`,
            data: {product},
        })
            .then((res) => {
                const result = res.data;
                if(result.code == Constant.RESPONSE.OK.code) {
                    alert(`결합 상품을 ${selected ? "수정했습니다." : "추가했습니다."}`);
                    onClose(true);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };
    
    const onClose = (dataRefresh) => {
        onHide(dataRefresh);
    };

    return (
        <Modal
            show={show}
            size="lg"
            onHide={() => {
                onClose(false);
            }}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">결합 상품 {selected ? "수정" : "등록"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input type="hidden" className="form-control" id="id" name="id" tabIndex="1" value={product.id || ""} />
                <div className="row">
                    <div className="col">
                        <label htmlFor="NAME">상품명</label>
                        <input type="text" className="form-control" id="name" name="name" tabIndex="2" onChange={changeHandler} value={product.name || ""} />
                    </div>
                    <div className="col">
                        <label htmlFor="NAME">상품 키</label>
                        <input type="text" className="form-control" id="type" name="type" tabIndex="3" onChange={changeHandler} value={product.type || ""} disabled={selected ? true : false} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <label htmlFor="NAME">상품 설명</label>
                        <input type="text" className="form-control" id="description" name="description" tabIndex="4" onChange={changeHandler} value={product.description || ""} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <label htmlFor="appId">주 계약 서비스</label>
                        <select className="form-control mt-2" id="appId" name="appId" value={product.appId} autoFocus onChange={changeHandler}>
                            {serviceAppList &&
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas) {
                                        return (
                                            <option key={`main-appId-${a.appId}`} value={a.appId}>
                                                {a.name}
                                            </option>
                                        )
                                    }
                            })}
                        </select>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <label>사용 가능 서비스</label><br />
                            {serviceAppList &&
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas) {
                                        return (
                                            <label className="custom-control custom-checkbox custom-control-inline" key={`app-available-${a.appId}`}>
                                                <input
                                                    className="custom-control-input"
                                                    type="checkbox"
                                                    value={a.appId}
                                                    name="subApps"
                                                    disabled={product.appId == a.appId}
                                                    checked={product.appId == a.appId || (product.subApps && product.subApps.findIndex((p) => p.appId == a.appId) > -1)}
                                                    onChange={onSubAppSelect}
                                                />
                                                <span className={`custom-control-label ${product.appId == a.appId ? 'text-primary font-weight-bold' : ''}`}>
                                                    {a.name}
                                                </span>
                                            </label>
                                        );
                                    }
                                })}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <label htmlFor="use" style={{display: "block"}} className="mt-3 mb-0">사용 여부</label>
                        <label className="custom-control custom-radio custom-control-inline ">
                            <input
                                type="radio"
                                name="use"
                                value="1"
                                checked={product.use == 1}
                                className="custom-control-input"
                                onChange={changeHandler} 
                            />
                            <span className="custom-control-label">사용</span>
                        </label>
                        <label className="custom-control custom-radio custom-control-inline ">
                            <input
                                type="radio"
                                name="use"
                                value="0"
                                checked={product.use == 0}
                                className="custom-control-input"
                                onChange={changeHandler} 
                            />
                            <span className="custom-control-label">미사용</span>
                        </label>
                    </div>
                    <div className="col">
                        <label htmlFor="NAME">정렬(오름차순)</label>
                        <input type="text" className="form-control" id="order" name="order" tabIndex="7" onChange={changeHandler} value={product.order || ""} />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="createDate">등록일</label>
                        <input type="text" className="form-control" disabled id="createDate" name="createDate" value={product.createDate || "-"} />
                    </div>
                    <div className="col">
                        <label htmlFor="updateDate">수정일</label>
                        <input type="text" className="form-control" disabled id="updateDate" name="updateDate" value={product.updateDate || "-"} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={upsertData}>
                    저장
                </button>
                <button className="btn btn-outline-dark" onClick={() => onHide(false)}>
                    취소
                </button>
            </Modal.Footer>
        </Modal>
    );
};


export { ManageProduct as default };
